module.exports = __webpack_public_path__ + "static/media/warningBrand.f49aa67c.svg";